export default __webpack_public_path__ + "assets/media/happy.eed672e4.png";